<script lang="ts">
	export let number: number;
	export let name: string;
	export let ytmCode: string;
</script>

<div>
	<a target="_blank" href={`https://music.youtube.com/watch?v=${ytmCode}`}>
		{number.toLocaleString('en-US', {
			minimumIntegerDigits: 2,
			useGrouping: false,
		})}. {name}
	</a>
</div>

<style>
	div {
		display: block;
		height: 6rem;
	}

	a {
		color: #1E90FF;
		text-decoration: none;
		font-weight: 700;
		font-size: 1.3rem;
	}

	a:hover, a:active, a:focus {
		text-decoration: underline;
	}
</style>
